module.exports = __webpack_public_path__ + "img/beer_id-36.5bf286d0.png";